import { Layout } from "@/components";
import ProtectedRoute from "../ProtectedRoute";
import { routes } from "../utils";
import { Navigate } from "react-router-dom";
import { Dashboard } from "@/pages";
import {
  ClientMgmtRoutes,
  EmployeeMgmtRoutes,
  MasterDataRoutes,
  ProjectOverviewRoutes,
} from ".";
import { Role, roles } from "@/lib/utils";

const AdminRoutes = () => {
  return {
    path: routes.admin,
    element: <ProtectedRoute allowedRoles={[roles.admin.value as Role]} />,
    children: [
      {
        path: "",
        element: <Layout />,
        children: [
          {
            path: "",
            element: <Navigate to={`/${routes.admin}/${routes.dashboard}`} />,
          },
          {
            path: routes.dashboard,
            element: <Dashboard />,
          },
          MasterDataRoutes(),
          EmployeeMgmtRoutes(),
          ClientMgmtRoutes(),
          ProjectOverviewRoutes(),
        ],
      },
    ],
  };
};

export default AdminRoutes;
